/* eslint-disable */
import {DateTime, Settings} from 'luxon';

const FORMAT_LIST = [
  'yyyy-MM-dd',
  'dd-MM-yyyy',
  'MM-dd-yyyy',
  'yyyy LLL dd',           // For dates like 2023 Sep 18
  'dd LLL yyyy',           // For dates like 18 Sep 2023
  'yyyy/MM/dd',
  'dd/MM/yyyy',
  'dd/MM/yyyy HH:mm',
  'dd/MM/yyyy hh:mm a',
  'dd.MM.yyyy',
  'dd.MM.yyyy HH:mm',
  'dd.MM.yyyy hh:mm a',
  'MM.dd.yyyy',
  'MM.dd.yyyy HH:mm',
  'MM.dd.yyyy hh:mm a',
  'MM/dd/yyyy HH:mm',
  'MM/dd/yyyy hh:mm a',
  'MM/dd/yyyy',
  'MMM dd, yyyy',           // For dates like Sep 18, 2023
  "EEE, dd MMM yyyy HH:mm:ss 'GMT'", // For RFC 1123 (HTTP) format
  "yyyy-MM-dd HH:mm:ss",
  "yyyy-MM-dd'T'HH:mm:ss",  // ISO 8601 without time zone
  "yyyy-MM-dd'T'HH:mm:ssZZ", // ISO 8601 with time zone
];

export default {
  computed: {
    getFirstFiveAvailableShippingDates() {
      const weekdays = [];
      let date = this.getToday();

      while (weekdays.length < 5) {
        if (date.weekday !== 6 && date.weekday !== 7) {  // Skip Saturday (6) and Sunday (7)
          weekdays.push(date);
        }
        date = date.plus({days: 1});
      }

      return weekdays;
    },
    getBrowserTimeZone() {
      const offsetInMinutes = new Date().getTimezoneOffset();

      const absoluteOffset = Math.abs(offsetInMinutes);

      const hours = Math.floor(absoluteOffset / 60);
      const minutes = absoluteOffset % 60;

      const sign = offsetInMinutes > 0 ? '-' : '+';

      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');

      return `${sign}${formattedHours}:${formattedMinutes}`;
    },
  },
  methods: {
    isDateInFuture(date) {
      const parsedDate = this.parseUnknownDate(date);
      if (parsedDate.isValid) {
        return parsedDate.diffNow().milliseconds > 0;
      }
      return false;
    },
    formatDate: (value, format = '', lang = '') => {
      if (!value) {
        return '-';
      }

      if (!format) {
        format = localStorage.getItem('date_format') ?? 'DD.MM.YYYY'
      }

      if (lang) {
        //Options: da/en, locale is already set in main.js
        //If we have some specific translates situation we can use lang to translate date
        Settings.defaultLocale = lang
      }
      const getOrdinalSuffix = (day, locale) => {
        if (!locale) {
          locale = navigator.language || navigator.userLanguage;
        }
        // Check if locale starts with 'en' (for English locales like en-US, en-GB, etc.)
        if (locale.startsWith('en')) {
          if (day >= 11 && day <= 13) return `th`; // Special case for 11, 12, 13
          switch (day % 10) {
            case 1:
              return `st`;
            case 2:
              return `nd`;
            case 3:
              return `rd`;
            default:
              return `th`;
          }
        } else {
          // For other locales, just return the day without suffix
          return `${day}.`;
        }
      }

      const parseUnknownDate = (date) => {
        for (const format of FORMAT_LIST) {
          const dt = DateTime.fromFormat(date, format);
          if (dt.isValid) {
            return dt;
          }
        }
        return DateTime.invalid('Unknown format');
      };

      const shipmentTransform = (withTime = false) => {
        // Convert the date string to a Luxon DateTime object
        const date = parseUnknownDate(value);

        const year = date.year;
        const currentYear = DateTime.now().year;
        const userDateFormat = localStorage.getItem('date_format') ?? 'DD.MM.YYYY';

        let ordinal = ''
        let appendYear = false;

        // US formats
        if (['MM.dd.yyyy', 'MM/dd/yyyy'].includes(userDateFormat)) {
          ordinal = getOrdinalSuffix(date.day);
          format = year === currentYear ? `ccc, LLL d` : `ccc, LLL d,`;
          if (year !== currentYear) {
            appendYear = true;
          }
        } else {
          format = year === currentYear ? 'ccc d. LLL' : 'ccc d. LLL yyyy';
        }

        const dateParts = [];
        dateParts.push(date.toFormat(format) + ordinal);
        if (appendYear) {
          dateParts.push(date.toFormat('yyyy'))
        }
        if (withTime) {
          const timeFormat = localStorage.getItem('time_format') ?? 'HH:mm';
          dateParts.push(date.toFormat(timeFormat))
        }
        return dateParts.join(' ').split(' ').map((word) => {
          return word[0].toUpperCase() + word.substring(1);
        }).join(" ");
      }

      if (format === 'shipment') {
        return shipmentTransform();
      } else if (format === 'shipment_last_update') {
        return shipmentTransform(true)
      }

      //Check is value valid for transform
      return parseUnknownDate(value).toFormat(format)
    },
    // Function to attempt parsing with multiple formats
    parseUnknownDate(dateStr) {
      for (const format of FORMAT_LIST) {
        const dt = DateTime.fromFormat(dateStr, format);
        if (dt.isValid) {
          return dt;
        }
      }
      return DateTime.invalid('Unknown format');
    },
    /**
     * Support addition (+01:30) and subtraction (-01:30)
     *
     * @param vreme
     * @param vremeZaDodavanje
     * @returns {string}
     */
    addTime(vreme, vremeZaDodavanje) {
      const sign = vremeZaDodavanje[0];
      // Razdvajanje sati i minuta
      const [ulazniSati, ulazneMinute] = vreme.split(":").map(Number);
      const [dodajSati, dodajMinute] = vremeZaDodavanje.slice(1).split(":").map(Number);

      // Dodavanje vremenaZaDodavanje vremenu
      let rezultatSati = ulazniSati + (dodajSati * (sign === '+' ? 1 : -1));
      let rezultatMinute = ulazneMinute + (dodajMinute * (sign === '+' ? 1 : -1));

      // Ako su minute veće ili manje od 60, dodaj sate i smanji minute
      if (rezultatMinute >= 60) {
        rezultatSati += Math.floor(rezultatMinute / 60);
        rezultatMinute %= 60;
      } else if (rezultatMinute < 0) {
        rezultatSati -= Math.ceil(Math.abs(rezultatMinute) / 60);
        rezultatMinute = (rezultatMinute % 60 + 60) % 60;
      }

      // Ako su sati veći ili manji od 24, normalizuj ih
      rezultatSati = (rezultatSati % 24 + 24) % 24;

      // Formatiranje rezultata
      return `${rezultatSati.toString().padStart(2, '0')}:${rezultatMinute.toString().padStart(2, '0')}`;
    },
    roundToNearest30MinAfterGiven(time) {
      let timeParts = time.split(":");
      let hours = parseInt(timeParts[0], 10);
      let minutes = parseInt(timeParts[1], 10);

      if (minutes <= 30) {
        minutes = 30;
      } else {
        minutes = 0;
        if (hours < 23) {
          hours++; // Ako nije trenutno 23:30, povećavamo sat za jedan
        } else {
          hours = 0; // Ako je trenutno 23:xx, postavljamo na 00:00
        }
      }

      // Konstruisanje rezultujućeg vremena u formatu "HH:MM"
      return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    },
    getHoursRangeArray(from, to, interval) {
      let arr = this.generateTimeSlots(from, to, interval);
      return arr.slice(arr.indexOf(from), arr.indexOf(to) + 1).map((time) => {
        //Here we can manipulate time for view
        const timeText = this.formatFromFormatToFormat(time, 'HH:mm', this.defaultTimeFormat())
        return {text: timeText, value: time};
      });
    },
    formatFromFormatToFormat(value, fromFormat, toFormat) {
      return DateTime.fromFormat(value, fromFormat).toFormat(toFormat)
    },
    getFormatedDate(dateTime, dateFormat) {
      const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let date = '';
      let d = new Date(dateTime);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let hours = String(d.getHours());
      let minutes = String(d.getMinutes());

      if (day < 10) day = `0${day}`
      if (month < 10) month = `0${month}`
      if (hours.length == 1) hours = `0${hours}`
      if (minutes.length == 1) minutes = `0${minutes}`

      if (!dateFormat) {
        date = `${d.getFullYear()}-${month}-${day}`
      }

      return {
        date: date,
        time: `${hours}:${minutes}`,
        dayOfWeek: weekday[d.getDay()]
      };
    },
    convertTimeToOffset(time, fromOffset, toOffset) {
      if (!time || !fromOffset || !toOffset) return time;

      // Koristi postojeće parseTimezoneOffset metode
      const fromOffsetHours = this.parseTimezoneOffset(fromOffset);
      const toOffsetHours = this.parseTimezoneOffset(toOffset);

      // Izračunaj razliku između zona
      const diffHours = toOffsetHours - fromOffsetHours;

      // Formatuj razliku za addTime metodu
      const sign = diffHours >= 0 ? '+' : '-';
      const absDiff = Math.abs(diffHours);
      const hours = Math.floor(absDiff);
      const minutes = Math.round((absDiff - hours) * 60);

      const diffString = `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

      // Koristi postojeću addTime metodu
      return this.addTime(time, diffString);
    },
    getTimeInGMT(offset, format = '') {

      offset = this.parseTimezoneOffset(offset);

      // Kreiramo trenutno vreme u UTC zoni
      const now = new Date();

      // Dobijamo UTC vreme u milisekundama
      const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);

      // Kreiramo novi datum dodavanjem GMT offseta
      const timeInZone = new Date(utcTime + (3600000 * offset));

      // Formatiramo vreme u string
      const year = timeInZone.getUTCFullYear();
      const month = String(timeInZone.getUTCMonth() + 1).padStart(2, '0');
      const day = String(timeInZone.getUTCDate()).padStart(2, '0');
      const hours = timeInZone.getHours().toString().padStart(2, '0');
      const minutes = timeInZone.getMinutes().toString().padStart(2, '0');
      const seconds = timeInZone.getSeconds().toString().padStart(2, '0');

      if (format === 'date') {
        return `${year}-${month}-${day}`;
      }

      return `${hours}:${minutes}`;
    },
    generateTimeSlots(fromTime, toTime, interval) {
      let slots = [];
      //Must be in 'HH:mm' format
      let currentTime = DateTime.fromFormat(fromTime, 'HH:mm');
      const endTime = DateTime.fromFormat(toTime, 'HH:mm');

      while (currentTime <= endTime) {
        slots.push(currentTime.toFormat('HH:mm'));
        currentTime = currentTime.plus({minutes: interval});
      }

      return slots;
    },
    parseTimezoneOffset(offset) {
      // Determine the sign
      let sign = offset[0] === '+' ? 1 : -1;

      // Extract hours and minutes
      let [hours, minutes] = offset.substring(1).split(':').map(Number);

      // Convert minutes to fractional hours
      let fractionalHours = minutes / 60;

      // Combine hours and fractional hours, apply the sign
      return sign * (hours + fractionalHours);
    },
    getDateTimeTimezoneDifferenceBetweenTwoTimezones(value, startingTimezone, endingTimezone) {
      const timeInGmtOffset = DateTime.fromSQL(value).setZone(startingTimezone);
      return timeInGmtOffset.setZone(endingTimezone).toFormat(this.defaultDateFormat())
    },
    getTimeTimezoneDifferenceBetweenTwoTimezones(value, startingTimezone, endingTimezone) {
      const today = DateTime.now().toFormat("yyyy-MM-dd"); // Get today's date
      const customDateTime = DateTime.fromISO(`${today}T${value}`); //
      const timeInGmtOffset = customDateTime.setZone(startingTimezone);
      return timeInGmtOffset.setZone(endingTimezone).toFormat(this.defaultTimeFormat());
    },
    formatTime(value) {
      const today = DateTime.now().toFormat("yyyy-MM-dd"); // Get today's date
      return DateTime.fromISO(`${today}T${value}`).toFormat(this.defaultTimeFormat());
    },
    calculateGMTOffsetTimeDifference(value, offset) {
      return this.getTimeTimezoneDifferenceBetweenTwoTimezones(value, `UTC${offset}`, this.userTimezone())
    },
    defaultDateTimeFormat() {
      return `${this.defaultDateFormat()} ${this.defaultTimeFormat()}`
    },
    defaultTimeFormat() {
      return localStorage.getItem('time_format') ?? 'HH:mm'
    },
    defaultDateFormat() {
      return localStorage.getItem('date_format') ?? 'DD.MM.YYYY'
    },
    userTimezone() {
      return localStorage.getItem('timezone') ?? 'Europe/Belgrade'
    },
    addDays(days) {
      return DateTime.now().setZone(this.userTimezone()).plus({days: days});
    },
    getToday() {
      return DateTime.now().setZone(this.userTimezone());
    },
    getTomorrow() {
      return this.addDays(1)
    },
    getDayLabel(date) {
      const today = this.getToday();
      const tomorrow = today.plus({days: 1});

      if (date.hasSame(today, 'day')) {
        return this.$t('LBL_TODAY')
      } else if (date.hasSame(tomorrow, 'day')) {
        return this.$t('LBL_TOMORROW')
      } else {
        return this.$t(date.toFormat('cccc'))
      }
    },
    formatRelativeDate(inputDate) {
      const locale = localStorage.getItem('lang');
      const now = DateTime.now();
      const date = this.parseUnknownDate(inputDate).setLocale(locale);

      const diff = now.diff(date, ['days', 'hours', 'minutes', 'seconds']).toObject();

      if (diff.days < 1) {
        if (diff.hours < 1) {
          if (diff.minutes < 1) {
            return locale === 'dk'
              ? `${Math.floor(diff.seconds)} sekunder siden`
              : `${Math.floor(diff.seconds)} seconds ago`;
          } else {
            return locale === 'dk'
              ? `${Math.floor(diff.minutes)} minutter siden`
              : `${Math.floor(diff.minutes)} minutes ago`;
          }
        } else {
          if (diff.hours > 10) {
            return locale === 'dk'
              ? `I dag kl. ${this.formatTime(date.toFormat('HH:mm:ss'))}`
              : `Today at ${this.formatTime(date.toFormat('HH:mm:ss'))}`;
          } else {
            return locale === 'dk'
              ? `${Math.floor(diff.hours)} timer siden`
              : `${Math.floor(diff.hours)} hours ago`;
          }
        }
      } else if (diff.days < 2 && date.hasSame(now.minus({days: 1}), 'day')) {
        return locale === 'dk'
          ? `I går kl. ${this.formatTime(date.toFormat('HH:mm:ss'))}`
          : `Yesterday at ${this.formatTime(date.toFormat('HH:mm:ss'))}`;
      } else {
        return this.formatDate(inputDate, 'shipment_last_update')
      }
    }
  },
}
